import _ from 'lodash';

export default function initializeLodash(Vue) {
  if (Vue.prototype.$_) return false;
  Object.defineProperty(Vue.prototype, '$_', { value: _ });
  return Vue.prototype.$_;
}
